<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Venta</p>
              <div class="ms-auto d-flex gap-2">
                
                <argon-button v-if="(user.role != '1' && form.status === 0) || user.role === '1'" color="success"
                  size="sm" @click="save">Guardar</argon-button>
                <argon-button v-if="form.status == 0 && form.id > 0" color="success" size="sm" @click="confirm">Formalizar</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Cliente</label>
                <div class="d-flex gap-2">
                  <select ref="clientSelect" class="form-select select2" style="width:100%;">
                  </select>
                  <argon-button color="success" size="sm" @click="openClientModal">
                    <i class="fa fa-user-plus"></i> 
                  </argon-button>
                </div>
              </div>

              <div class="d-none">
                <div class="col-md-6">
                  <label for="document-type" class="form-control-label">Tipo de Documento</label>
                  <select id="documentType" class="form-control" v-model="form.document_type" :disabled="form.client_id > 0">
                    <option value="" disabled>Seleccione un tipo de documento</option>
                    <option value="CC">Cédula de Ciudadanía (CC)</option>
                    <option value="CE">Cédula de Extranjería (CE)</option>
                    <option value="TI">Tarjeta de Identidad (TI)</option>
                    <option value="RC">Registro Civil (RC)</option>
                    <option value="PA">Pasaporte (PA)</option>
                    <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                    <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Número documento</label>
                  <argon-input type="text" v-model="form.document" autocomplete="off" :disabled="form.client_id > 0" />
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Dirección</label>
                  <argon-input type="text" v-model="form.address" autocomplete="off" :disabled="form.client_id > 0" />
                </div>


                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Telefono</label>
                  <argon-input type="text" v-model="form.phone" :disabled="form.client_id > 0" />
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Email</label>
                  <argon-input type="text" v-model="form.email" :disabled="form.client_id > 0" />
                </div>
              </div>

              <!-- <div class="col-md-6">
                <label for="example-select-input" class="form-control-label">Seleccionar tipo</label>
                <select v-model="form.type" class="form-control">
                  <option value="production">Taller</option>
                  <option value="return">Devolución</option>
                </select>
              </div> -->

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" />
              </div>


            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <argon-button v-if="user.role === '1' || user.role === '2'" color="success" size="sm" class="ms-auto"
                @click="addDetail">Agregar producto</argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Origen</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Taller / Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo / Ref
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Precio
                      </th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Total
                      </th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="(user.role !== '1' && form.status === 0) || user.role === '1'">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td class="align-middle text-center text-sm">
                        <span class="badge" :class="value.inventory_id ? 'bg-info' : 'bg-primary'">
                          {{ value.inventory_id ? 'Inventario' : 'Taller' }}
                        </span>
                      </td>
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ value.inventory_id ? 'Inventario directo' : (value.production_model?.production?.name ?? value.produccion?.name ?? 'No encontrado') }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ value.inventory_id ? (value.inventory?.name ?? value.inventory?.ref ?? 'N/A') : (value.production_model?.model?.name ?? value.model?.name ?? "No encontrado") }}
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ value.quantity }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center" v-if="user.role === '1' || user.role === '2'">

                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                           data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar Cliente -->
    <div class="modal fade" id="ModalClient" tabindex="-1" aria-labelledby="clientModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="clientModalLabel">Agregar Cliente</h5>
            <button type="button" class="btn-close" @click="closeClientModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="client-name" class="form-label">Nombre</label>
                <input type="text" v-model="newClient.name" id="client-name" class="form-control"
                  placeholder="Ingrese el nombre del cliente" required>
              </div>
              <div class="mb-3">
                <label for="client-document-type" class="form-label">Tipo de Documento</label>
                <select id="client-document-type" class="form-select" v-model="newClient.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="client-document" class="form-label">Número de Documento</label>
                <input type="text" v-model="newClient.document" id="client-document" class="form-control"
                  placeholder="Ingrese el número de documento" required>
              </div>
              <div class="mb-3">
                <label for="client-address" class="form-label">Dirección</label>
                <input type="text" v-model="newClient.address" id="client-address" class="form-control"
                  placeholder="Ingrese la dirección">
              </div>
              <div class="mb-3">
                <label for="client-phone" class="form-label">Teléfono</label>
                <input type="text" v-model="newClient.phone" id="client-phone" class="form-control"
                  placeholder="Ingrese el teléfono" required>
              </div>
              <div class="mb-3">
                <label for="client-email" class="form-label">Email</label>
                <input type="email" v-model="newClient.email" id="client-email" class="form-control"
                  placeholder="Ingrese el email" required>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeClientModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveClient">Guardar Cliente</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de remision -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="submitForm" ></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label class="form-label">Origen del producto</label>
                <div class="source-type-options">
                  <label
                    class="source-type-option"
                    :class="{ active: modal.sourceType === 'production' }"
                  >
                    <input type="radio" v-model="modal.sourceType" value="production" class="form-check-input" @change="onSourceTypeChange">
                    <span class="form-check-label">Taller (producción)</span>
                  </label>
                  <label
                    class="source-type-option"
                    :class="{ active: modal.sourceType === 'inventory' }"
                  >
                    <input type="radio" v-model="modal.sourceType" value="inventory" class="form-check-input" @change="onSourceTypeChange">
                    <span class="form-check-label">Inventario directo</span>
                  </label>
                </div>
              </div>

              <div class="mb-3" v-show="modal.sourceType === 'production'">
                <label for="modelSelect" class="form-label">Modelo (taller)</label>
                <select ref="ModelSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3" v-show="modal.sourceType === 'inventory'">
                <label for="inventorySelect" class="form-label">Producto (inventario)</label>
                <select ref="InventorySelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="modal.quantity" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Precio Unidad</label>
                <input type="text" v-model="formattedPrice" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input type="text" v-model="totalPrice" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';


const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        name: '',
        client_id: 0,
        document_type:'',
        document:'',
        address:'',
        phone: '',
        email: '',
        observation: '',
        status: 0,
        type: 'production',
      },
      data: {},
      modal: {
        id: 0,
        remission_id: 0,
        model_id: 0,
        inventory_id: 0,
        sourceType: 'production', // 'production' | 'inventory'
        quantity: 0,
        price: 0,
        total: 0
      },
      inventoryList: [],
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      clients: [],
      clientModal: null,
      newClient: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4', // Cliente
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea },
  computed: {
    formattedPrice: {
      get() {
        return this.modal.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.price = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
      },
    },
    totalPrice: {
      get() {
        return this.modal.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.total = Math.floor(value.replace(/\./g, "") || 0);
        this.modal.price = this.modal.quantity > 0 ? Math.floor((this.modal.total / this.modal.quantity)) : 0;
      },
    },
  },
  watch: {
    "modal.quantity"(newQuantity) {
      this.modal.total = Math.floor(this.modal.price * newQuantity);
    },
  },
  methods: {
    redirectToRemissionsTable() {
      this.$router.push('/remissions');
    },
    async getClients() {
      try {
        // Obtener todos los usuarios con role 4 (clientes)
        const response = await this.$store.dispatch('users/getAll');
        let users = [];
        
        // El backend devuelve directamente un array cuando page=all
        if (Array.isArray(response)) {
          users = response;
        } else if (response && response.data) {
          // Si viene con estructura de respuesta
          if (Array.isArray(response.data)) {
            users = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            users = response.data.data;
          }
        }
        
        // Filtrar solo clientes (role == '4')
        this.clients = users.filter(user => user.role == '4');

        // Si la remisión viene sin client_id pero con documento, intentar
        // encontrar el cliente por documento para mantener compatibilidad
        if (!this.form.client_id && this.form.document) {
          const byDocument = this.clients.find(c => c.document === this.form.document);
          if (byDocument) {
            this.form.client_id = byDocument.id;
          }
        }
        
        this.$nextTick(() => {
          const select = $(this.$refs.clientSelect);
          
          if (select.hasClass("select2-hidden-accessible")) {
            select.select2('destroy');
          }
          select.empty();
          select.append('<option value="" disabled selected>Seleccionar cliente</option>');
          
          this.clients.forEach(client => {
            const displayText = `${client.name} - ${client.email || client.phone || ''}`;
            select.append(new Option(displayText, client.id, false, false));
          });
          
          select.select2({
            placeholder: 'Seleccione un cliente',
            allowClear: true,
          });
          
          select.on('change', () => {
            const selectedId = select.val();
            if (selectedId) {
              const selectedClient = this.clients.find(c => c.id == selectedId);
              if (selectedClient) {
                this.form.client_id = selectedClient.id;
                this.form.name = selectedClient.name;
                this.form.email = selectedClient.email || '';
                this.form.phone = selectedClient.phone || '';
                this.form.address = selectedClient.address || '';
                this.form.document = selectedClient.document || '';
                this.form.document_type = selectedClient.document_type || '';
              }
            } else {
              this.form.client_id = 0;
              this.form.name = '';
              this.form.email = '';
              this.form.phone = '';
              this.form.address = '';
              this.form.document = '';
              this.form.document_type = '';
            }
          });
          
          // Si hay un cliente seleccionado, establecerlo
          if (this.form.client_id > 0) {
            select.val(this.form.client_id).trigger('change');
          }
        });
      } catch (error) {
        console.error('Error al obtener clientes:', error);
      }
    },
    openClientModal() {
      // Resetear el formulario del nuevo cliente
      this.newClient = {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4',
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      };
      
      const modalElement = document.getElementById('ModalClient');
      this.clientModal = new Modal(modalElement);
      this.clientModal.show();
    },
    closeClientModal() {
      if (this.clientModal) {
        this.clientModal.hide();
      }
    },
    async saveClient() {
      try {
        // Validar campos requeridos
        if (!this.newClient.name || !this.newClient.email || !this.newClient.phone) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campos requeridos',
            text: 'Por favor complete todos los campos obligatorios.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        
        // Crear el cliente en usuarios
        const response = await this.$store.dispatch('users/save', this.newClient);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El cliente ha sido registrado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          
          // Recargar la lista de clientes
          await this.getClients();
          
          // Seleccionar el nuevo cliente
          this.$nextTick(() => {
            const select = $(this.$refs.clientSelect);
            select.val(response.data.id).trigger('change');
          });
          
          this.closeClientModal();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el cliente');
        }
      } catch (error) {
        console.error("Error al crear el cliente:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el cliente',
        });
      }
    },
    async getModels() {
      // Obtener productos de production-model
      const response = await this.$store.dispatch('productionModels/getAll');
      
      // El store devuelve response.data cuando es getAll con page='all'
      let products = [];
      if (Array.isArray(response)) {
        products = response;
      } else if (response && response.data) {
        products = Array.isArray(response.data) ? response.data : [];
      }
      
      console.log('Respuesta completa:', response);
      console.log('Productos recibidos:', products);
      console.log('Total productos:', products.length);

      if (products.length === 0) {
        console.warn('No se recibieron productos');
      }

      this.$nextTick(() => {
        const select = $(this.$refs.ModelSelect);

        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }
        select.empty();
        select.append('<option value="" disabled selected>Seleccionar modelo</option>');
        
        // Filtrar solo productos con stock mayor a cero
        const productsWithStock = products.filter(prod => {
          const stock = parseFloat(prod.stock || 0);
          return stock > 0;
        });
        
        console.log('Productos con stock:', productsWithStock.length);
        
        // Guardar los productos filtrados para usarlos después
        this.models = { data: productsWithStock };
        
        productsWithStock.forEach(prod => {
          const displayText = `#${prod.model?.id || prod.id} - ${prod.model?.name || 'Sin nombre'} (${prod.model?.ref || 'Sin ref'}) - TALLA: ${prod.size?.size || 'N/A'} - COLOR: ${prod.size?.color?.name || 'N/A'} \nPRODUCCIÓN: #${prod.production?.id || 'N/A'} - ${prod.production?.name || 'Sin nombre'} \nBODEGA: ${prod?.production?.bodega?.name || 'Sin asignar'} - STOCK: ${prod.stock || 0}`;
          select.append(new Option(displayText, prod.id, false, false));
        });

        $(this.$refs.ModelSelect).select2({
          placeholder: 'Seleccione un Producto de Inventario de producción',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ModelSelect).on('change', () => {
          this.modal.model_id = $(this.$refs.ModelSelect).val();

            const selectedModel = this.models.data.find(prod => prod.id == this.modal.model_id );

            if (selectedModel) {
              // Usar el precio de venta (selling_cost) de la producción si existe
              this.modal.price = parseFloat(selectedModel.production?.selling_cost || selectedModel.production?.price || selectedModel.price || 0);

              if(this.modal.id==0){
                // Establecer la cantidad inicial como el stock disponible
                this.modal.quantity = selectedModel.stock || 1;
              }

             this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
          }
        });
      });
    },
    addDetail() {
      this.modal.id = 0;
      this.modal.remission_id = this.form.id; // Establecer el ID de la remisión
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.quantity = 0;
      this.modal.price = 0;
      this.modal.total = 0;

      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la venta primero antes de agregar productos.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.modal.sourceType = 'production';
      this.modal.inventory_id = 0;
      this.getModels();
      this.getInventory();
      $(this.$refs.ModelSelect).val("").trigger('change');
      this.$nextTick(() => {
        if (this.$refs.InventorySelect && $(this.$refs.InventorySelect).length) $(this.$refs.InventorySelect).val("").trigger('change');
      });
      this.openModal();
    },
    onSourceTypeChange() {
      this.modal.model_id = 0;
      this.modal.inventory_id = 0;
      this.modal.quantity = 0;
      this.modal.price = 0;
      this.modal.total = 0;
      this.$nextTick(() => {
        if (this.modal.sourceType === 'production' && this.$refs.ModelSelect) {
          $(this.$refs.ModelSelect).val("").trigger('change');
        }
        if (this.modal.sourceType === 'inventory' && this.$refs.InventorySelect) {
          $(this.$refs.InventorySelect).val("").trigger('change');
        }
      });
    },
    async getInventory() {
      const response = await this.$store.dispatch('inventory/getAll');
      let items = [];
      if (Array.isArray(response)) items = response;
      else if (response?.data) items = Array.isArray(response.data) ? response.data : [];
      this.inventoryList = (items || []).filter(inv => parseFloat(inv.quantity || 0) > 0);
      this.$nextTick(() => {
        if (!this.$refs.InventorySelect) return;
        const select = $(this.$refs.InventorySelect);
        if (select.hasClass('select2-hidden-accessible')) select.select2('destroy');
        select.empty();
        select.append('<option value="" disabled selected>Seleccionar producto</option>');
        this.inventoryList.forEach(inv => {
          const stock = parseFloat(inv.quantity || 0);
          const text = `${inv.name || 'Sin nombre'} (${inv.ref || ''}) - Stock: ${stock}`;
          select.append(new Option(text, inv.id, false, false));
        });
        select.select2({
          placeholder: 'Seleccione producto de inventario',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });
        select.off('change.remissionInventory').on('change.remissionInventory', () => {
          this.modal.inventory_id = select.val() ? parseInt(select.val(), 10) : 0;
          const inv = this.inventoryList.find(i => i.id == this.modal.inventory_id);
          if (inv) {
            this.modal.price = parseFloat(inv.price || 0);
            if (this.modal.id === 0) this.modal.quantity = Math.min(1, parseFloat(inv.quantity || 0)) || 1;
            this.modal.total = Math.floor(this.modal.price * this.modal.quantity);
          }
        });
      });
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    async getData() {
      this.data = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
    },
    async confirm() {
      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la venta primero antes de formalizarla.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      // Verificar que tenga detalles
      if (!this.data.data || this.data.data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe agregar al menos un producto antes de formalizar la venta.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'info',
        title: 'Formalizar venta',
        text: 'Al formalizar la venta se restará el stock: en productos de taller (quantity_sent) y en productos de inventario directo (cantidad en inventario). Ya no se podrá editar los registros ni los detalles de la venta.',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        backdrop: true,
      });

      if (result.isConfirmed) {
        try {
          const response = await this.$store.dispatch("remissions/formalize", this.form.id);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'La venta ha sido formalizada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            }).then(async () => {
              this.form.status = 1;
              await this.getData();
              this.openTicket();
              this.redirectToRemissionsTable();
            });
          } else {
            throw new Error(response.data?.message || 'Error al formalizar la venta');
          }
        } catch (error) {
          console.error("Error al formalizar la venta:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || error.message || 'Error al formalizar la venta',
            confirmButtonText: 'Aceptar'
          });
        }
      }
    },
    async save() {
      try {
        // Si hay un cliente seleccionado pero no existe en usuarios, crearlo
        if (this.form.name && this.form.client_id == 0) {
          // Verificar si el cliente ya existe por email o nombre
          const existingClient = this.clients.find(c => 
            c.email === this.form.email || c.name === this.form.name
          );
          
          if (!existingClient && this.form.email && this.form.name) {
            // Crear el cliente en usuarios
            const clientData = {
              id: 0,
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone || '',
              address: this.form.address || '',
              document_type: this.form.document_type || 'CC',
              document: this.form.document || '',
              role: '4', // Cliente
              status: '1',
              password: 'cliente123',
              password_confirmation: 'cliente123',
              payment: '0',
              processes: [],
            };
            
            const clientResponse = await this.$store.dispatch('users/save', clientData);
            
            if (clientResponse && clientResponse.status >= 200 && clientResponse.status < 300) {
              this.form.client_id = clientResponse.data.id;
              // Recargar la lista de clientes
              await this.getClients();
            }
          } else if (existingClient) {
            this.form.client_id = existingClient.id;
          }
        }
        
        // Dispara la acción de Vuex para guardar la remisión
        const response = await this.$store.dispatch("remissions/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;
              
              // Actualizar el remission_id en el modal si está abierto
              if (this.modal.remission_id === 0) {
                this.modal.remission_id = this.form.id;
              }
              
              this.getData().then(() => {
                this.openTicket();
                this.redirectToRemissionsTable();
              });

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {
        if (this.modal.sourceType === 'production') {
          const selectedModel = this.models.data && this.models.data.find(prod => prod.id == this.modal.model_id);
          if (!selectedModel) {
            await Swal.fire({ icon: 'warning', title: 'Seleccione un modelo de taller.', confirmButtonText: 'Aceptar' });
            return;
          }
          if (this.modal.quantity > (selectedModel.stock || 0)) {
            await Swal.fire({ icon: 'warning', title: 'Cantidad excedida', text: 'La cantidad supera el stock disponible en taller.', confirmButtonText: 'Aceptar' });
            return;
          }
        } else {
          const selectedInv = this.inventoryList.find(i => i.id == this.modal.inventory_id);
          if (!selectedInv) {
            await Swal.fire({ icon: 'warning', title: 'Seleccione un producto de inventario.', confirmButtonText: 'Aceptar' });
            return;
          }
          const stockInv = parseFloat(selectedInv.quantity || 0);
          if (this.modal.quantity > stockInv) {
            await Swal.fire({ icon: 'warning', title: 'Cantidad excedida', text: 'La cantidad supera el stock disponible en inventario.', confirmButtonText: 'Aceptar' });
            return;
          }
        }

        const payload = {
          id: this.modal.id,
          remission_id: this.modal.remission_id,
          quantity: this.modal.quantity,
          price: this.modal.price,
          total: this.modal.total,
        };
        if (this.modal.sourceType === 'production') {
          payload.model_id = this.modal.model_id;
          payload.inventory_id = null;
        } else {
          payload.inventory_id = this.modal.inventory_id;
          payload.model_id = 0;
        }

        const response = await this.$store.dispatch("remissionsDetails/save", payload);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.modal.id = 0;
              this.modal.model_id = 0;
              this.modal.inventory_id = 0;
              this.modal.sourceType = 'production';
              this.modal.quantity = 0;
              this.modal.price = 0;
              this.modal.total = 0;
              if (this.$refs.ModelSelect) $(this.$refs.ModelSelect).val('').trigger('change');
              if (this.$refs.InventorySelect) $(this.$refs.InventorySelect).val('').trigger('change');
              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(params) {
      this.modal.id = params.id;
      this.modal.remission_id = params.remission_id;
      this.modal.quantity = params.quantity;
      this.modal.price = params.price;
      this.modal.total = params.total;
      this.modal.sourceType = params.inventory_id ? 'inventory' : 'production';
      this.modal.model_id = params.production_models_id || 0;
      this.modal.inventory_id = params.inventory_id || 0;

      this.getModels();
      this.getInventory();
      this.openModal();

      await new Promise(resolve => setTimeout(resolve, 800));

      if (this.modal.sourceType === 'production' && this.$refs.ModelSelect) {
        $(this.$refs.ModelSelect).val(this.modal.model_id).trigger('change');
      } else if (this.modal.sourceType === 'inventory' && this.$refs.InventorySelect) {
        $(this.$refs.InventorySelect).val(this.modal.inventory_id).trigger('change');
      }
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    formatTicketMoney(value) {
      return Number(value || 0).toLocaleString('es-CO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    openTicket() {
      try {
        const details = Array.isArray(this.data?.data) ? this.data.data : [];
        const detailRows = details.map((item) => {
          const name = item.inventory_id
            ? (item.inventory?.name || item.inventory?.ref || 'Inventario')
            : (item.production_model?.model?.name || item.model?.name || 'Modelo');
          const qty = Number(item.quantity || 0);
          const price = this.formatTicketMoney(item.price);
          const total = this.formatTicketMoney(item.total);
          return `
            <tr>
              <td>${name}</td>
              <td class="text-right">${qty}</td>
              <td class="text-right">$${price}</td>
              <td class="text-right">$${total}</td>
            </tr>
          `;
        }).join('');

        const totalGeneral = details.reduce((acc, item) => acc + Number(item.total || 0), 0);
        const ticketWindow = window.open('', '_blank');

        if (!ticketWindow) {
          Swal.fire({
            icon: 'warning',
            title: 'Ventana bloqueada',
            text: 'Permite las ventanas emergentes para ver el ticket.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        const clientName = this.form.name || 'Cliente no definido';
        const clientDoc = this.form.document || 'N/A';
        const dateText = new Date().toLocaleString('es-CO');

        ticketWindow.document.write(`
          <!DOCTYPE html>
          <html lang="es">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Ticket Venta #${this.form.id}</title>
            <style>
              * { box-sizing: border-box; }
              body {
                margin: 0;
                padding: 10px;
                font-family: Arial, sans-serif;
                background: #f5f5f5;
              }
              .ticket {
                width: 100mm;
                max-width: 100mm;
                margin: 0 auto;
                background: #fff;
                color: #000;
                padding: 12px;
                border: 1px solid #ddd;
              }
              .title {
                text-align: center;
                font-weight: 700;
                margin-bottom: 8px;
              }
              .meta {
                font-size: 12px;
                line-height: 1.4;
                margin-bottom: 8px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                font-size: 11px;
              }
              th, td {
                border-bottom: 1px dashed #ccc;
                padding: 4px 0;
                vertical-align: top;
              }
              th {
                text-align: left;
              }
              .text-right {
                text-align: right;
                white-space: nowrap;
              }
              .total {
                margin-top: 8px;
                font-size: 13px;
                font-weight: 700;
                text-align: right;
              }
              .actions {
                width: 100mm;
                max-width: 100mm;
                margin: 12px auto 0;
                display: flex;
                gap: 8px;
              }
              .btn {
                flex: 1;
                border: none;
                padding: 8px 10px;
                border-radius: 6px;
                cursor: pointer;
                color: #fff;
                font-weight: 600;
              }
              .btn-close { background: #6c757d; }
              .btn-print { background: #2dce89; }
              @media print {
                body { background: #fff; padding: 0; }
                .ticket { border: none; width: 100mm; max-width: 100mm; margin: 0 auto; }
                .actions { display: none; }
              }
            </style>
          </head>
          <body>
            <div class="ticket">
              <div class="title">TICKET DE VENTA</div>
              <div class="meta">
                <div><strong>Nro:</strong> ${this.form.id}</div>
                <div><strong>Fecha:</strong> ${dateText}</div>
                <div><strong>Cliente:</strong> ${clientName}</div>
                <div><strong>Documento:</strong> ${clientDoc}</div>
                <div><strong>Observación:</strong> ${this.form.observation || 'Sin observación'}</div>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Producto</th>
                    <th class="text-right">Cant.</th>
                    <th class="text-right">Precio</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  ${detailRows || '<tr><td colspan="4">Sin productos</td></tr>'}
                </tbody>
              </table>
              <div class="total">TOTAL: $${this.formatTicketMoney(totalGeneral)}</div>
            </div>
            <div class="actions">
              <button class="btn btn-close" onclick="window.close()">Cerrar</button>
              <button class="btn btn-print" onclick="window.print()">Imprimir</button>
            </div>
          </body>
          </html>
        `);
        ticketWindow.document.close();
      } catch (error) {
        console.error("Error al abrir el ticket:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No fue posible abrir el ticket de la venta.',
        });
      }
    },
  },
  mounted() {
  
    this.user = JSON.parse(localStorage.getItem('user'));
    const route = useRoute();
    const dataEdit = route.params.data;

    // Cargar clientes al iniciar
    this.getClients();

    if (dataEdit) {

      this.getModels();

      try {
        const params = JSON.parse(dataEdit); // Asegúrate de que este JSON se pueda parsear
        this.data = params;
        if (params && params.id) {

          this.form.id = params.id || 0;
          this.form.name = params.name || '';
          this.form.client_id = params.client_id || 0;
          this.form.document_type = params.document_type || '';
          this.form.document = params.document || '';
          this.form.address = params.address || '';
          this.form.phone = params.phone || '';
          this.form.email = params.email || '';
          this.form.type = params.type || 'production';
          this.form.observation = params.observation || '';
          this.form.status = params.status || 0;

          this.modal.remission_id = params.id || 0;

          // Establecer el cliente seleccionado en el select2
          this.$nextTick(() => {

            console.log(this.form.client_id, 'this.form.client_id');
            if (this.form.client_id > 0) {
              const select = $(this.$refs.clientSelect);
              select.val(this.form.client_id).trigger('change');
            }
          });

          this.getData();
        }
      } catch (error) {
        console.error("Error al parsear los datos del registro:", error);
      }
    }
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.source-type-options {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.source-type-option {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.85rem;
  border: 1px solid #d2d6da;
  border-radius: 0.55rem;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0;
}

.source-type-option:hover {
  border-color: #5e72e4;
  background: #f8f9ff;
}

.source-type-option.active {
  border-color: #5e72e4;
  background: #eef1ff;
  box-shadow: 0 0 0 0.15rem rgba(94, 114, 228, 0.15);
}

.source-type-option .form-check-input {
  margin: 0;
  width: 1rem;
  height: 1rem;
  border: 2px solid #344767;
  background-color: #fff;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 50%;
  position: relative;
}

.source-type-option .form-check-input:checked {
  background-color: #344767;
}

.source-type-option .form-check-input:focus {
  box-shadow: 0 0 0 0.15rem rgba(52, 71, 103, 0.2);
}

.source-type-option .form-check-label {
  margin: 0;
  color: #344767;
  font-weight: 600;
}
</style>
